<template>
    <div class="form-group">
        <label :for="uid">{{ label }}</label>
        <textarea :id="uid" class="form-control" :placeholder="placeholder" :value="modelValue" @input="update"></textarea>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop } from '@/helpers/Decorators';

@Options({
    name: 'field-textarea'
})
export default class FieldTextarea extends Vue
{
    @Prop() public label: string;
    @Prop() public modelValue: string;
    @Prop() public placeholder: string;

    public get uid(): string
    {
        return `form-field-${this.$.uid}`;
    }

    @Emit('update:modelValue')
    public update(e: any): string
    {
        return e.target.value;
    }
}
</script>
